export const getEmailRecipients = (withGiftVoucher?: boolean, studentContactEmail?: string, studentEmail?: string): string[] => {
  const recipients: string[] = []

  if (studentContactEmail) {
    recipients.push(studentContactEmail)
  }

  if (!withGiftVoucher && studentEmail) {
    recipients.push(studentEmail)
  }

  return recipients
}
